export const LogoMark = ({ size = 38 }) => (
  <img
    src="/logo-mark.png"
    width={size}
    height={size}
    alt="CabNow"
    className="rounded-xl object-cover"
    data-testid="cabnow-logo-mark"
  />
);

export const Logo = ({ light = false }) => (
  <img
    src={light ? "/logo-white.webp" : "/logo-blue.webp"}
    alt="CabNow — Votre satisfaction est notre destination"
    data-testid="cabnow-logo"
    className={light ? "h-11 w-auto" : "h-11 w-auto rounded-xl shadow-md"}
  />
);
